
export default function upload(option) {
	const axios = window.axios;

	if (typeof axios === 'undefined') {
		return;
	}

	const url = option.action;

	const formData = new FormData();

	if (option.data) {
		Object.keys(option.data).forEach(key => {
			formData.append(key, option.data[key]);
		});
	}

	formData.append(option.filename, option.file, option.file.name);

	const headers = option.headers || {};

	const config = {
		url,
		method: 'post',
		data: formData,
		headers,
		withCredentials: option.withCredentials,
		onUploadProgress:function (e) {
			if (e.total > 0) {
				e.percent = e.loaded / e.total * 100;
			}
			option.onProgress(e);
		}
	};

	return new Promise(async (resolve,reject)=>{
		try {
			const {data} = await axios(config);
			resolve(data);
		}catch (e) {
			reject(e);
		}
	});
}
